





import { defineComponent, reactive, ref } from '@vue/composition-api';

export default defineComponent({
	setup() {
		const blog = ref();
		const state = reactive({
			loading: false,
			displayViewMore: true,
		});
		function onLoadMoreClick(e: Event, url: string) {
			e.preventDefault();
			state.loading = true;

			const entryList = (blog.value as HTMLDivElement).querySelector('.wb-entry-list');
			const urlParams = new URLSearchParams(window.location.search);

			const params: {
				startIndex: string;
				blogAjax: string;
				tag?: string;
				sort?: string;
			} = {
				startIndex: (entryList?.querySelectorAll('section').length || 0).toString(),
				blogAjax: '1',
			};
			if (urlParams.has('tag')) {
				params.tag = urlParams.get('tag') || undefined;
			}
			if (urlParams.has('sort')) {
				params.sort = urlParams.get('sort') || undefined;
			}

			const fetchUrl = `${url}${url.includes('?') ? '&' : '?'}${new URLSearchParams(params).toString()}`;

			fetch(fetchUrl, {
				method: 'GET',
			})
				.then((res) => res.text())
				.then((data) => {
					const template = document.createElement('template');
					data = data.trim();
					template.innerHTML = data;
					const entries = template.content.firstElementChild?.querySelectorAll('section');
					if (entryList && entries) {
						entries.forEach((entry) => {
							entryList.lastChild?.before(entry);
						});
					} else {
						state.displayViewMore = false;
					}
					state.loading = false;
				});
		}
		return { onLoadMoreClick, state, blog };
	},
});
